import { render, staticRenderFns } from "./TepTarifaNacional.vue?vue&type=template&id=3ef87490"
import script from "./TepTarifaNacional.vue?vue&type=script&lang=js"
export * from "./TepTarifaNacional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports